<script>
  import { page, navigating, session } from '$app/stores';

  import Header from '$lib/components/header/index.svelte';
  import Footer from '$lib/components/footer/index.svelte';
  import PreloadingIndicator from '$lib/components/preloading-indicator.svelte';

  import '../app.css';
</script>

{#if $navigating && $navigating.to}
  <PreloadingIndicator />
{/if}

<main class="min-h-full">
  <Header />
  <slot />
  <Footer />
</main>
